export const recentTransactions = {
  emptyLabel:
    'you don&apos;t have recent <br /> transactions yet, when you do <br /> they will appear here',
  title: 'Recent transactions',
  to: 'To:',
  from: 'From:'
};
